import { Logger } from "../../02_utils/logger";
import { Utils } from "../../02_utils/utils";


export class MediaText {
  constructor(private $log: Logger, private $utils: Utils) {
    const mediaTexts: NodeListOf<HTMLElement> = document.querySelectorAll('.js-media-text');

    mediaTexts?.forEach(mediaText => {
      this.handleMediaText(mediaText);
    });
  }

  private handleMediaText(mediaText: HTMLElement) {
    const images: NodeListOf<HTMLElement> = mediaText.querySelectorAll('.js-media-text-image');
    const imagePercent = 100 / images.length;
    var minThreshold = 0;

    document.addEventListener('scroll', event => {
      const boundingClientRect = mediaText.getBoundingClientRect();
      const scrollPercent = 100 - ((boundingClientRect.y + boundingClientRect.height) / boundingClientRect.height * 100);

      if (scrollPercent <= 100 && scrollPercent >= 0) {

        // Loop through all the images for calculation purpose.
        // index * imagePercent will tell you all the minimum thresholds between images. e.g 5 images => switch each image after 20% scrolling.
        // index 0 * 20 = minTreshold of 0.
        // index 1 * 20 = minTreshold of 20.
        // index 2 * 20 = minTreshold of 40.
        // index 3 * 20 = minTreshold of 60.
        // index 4 * 20 = minTreshold of 80.
        // The maximum threshold is just the minimum threshold + the amount to scroll for each image (20% in our example).
        // For the first image the scrolling threshold will be between 0 and 20. The second will be between 20 and 40.
        // If the scrollPercent is between 0 and 20 show the first image and so on.
        for (let index = 0; index < images.length; index++) {
          minThreshold = (index * imagePercent) / 2; // Divided by 2 for better visibility

          if (scrollPercent > minThreshold && scrollPercent <= minThreshold + imagePercent) {
            images.forEach((image: HTMLElement) => {
              image.classList.remove('active');
            });

            images[index].classList.add('active');
          }
        }
      }
    });
  }
}
